module.exports = "<div class=\"card-header\">\n\t<h4 class=\"card-title\">Listado de formas de pago</h4>\n\t<hr>\n</div>\n\n<div class=\"card-content\">\n\t<div class=\"buttons\">\n\t\t<a [routerLink]=\"['/cobro/forma-pago/crear']\" class=\"btn btn-info btn-fill\">\n\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\tNuevo\n\t\t</a>\n\t</div>\n\t<br>\n\n\t<grid [dataGrid]=\"dataGrid\"></grid>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/cobros/forma-pago-list/forma-pago-list.component.html
// module id = ../../../../../src/app/components/cobros/forma-pago-list/forma-pago-list.component.html
// module chunks = main